module.exports = __webpack_public_path__ + "img/center55.4e74958c.png";